import SearchStore from './SearchStore'

export default SearchStore
